<div
    class="container cmps-notification"
    [tabindex]="index === 0 ? 0 : -1"
    [attr.aria-labelledby]="'notification' + index + 'Content'"
    [attr.aria-describedby]="
        (isCollapsed ? i18n._689_READ_MORE : i18n._690_READ_LESS) | translate
    "
    [attr.aria-expanded]="!isCollapsed"
    (focusin)="_keyboardNavigator.onFocusInOut($event)"
    (focusout)="_keyboardNavigator.onFocusInOut($event)"
    (click)="onReadMoreClick($event)"
>
    <div
        class="row header"
        [hidden]="!isDismissed"
        [ngClass]="{ undo: isDismissed }"
        [class.cmps-notification--header--expanded]="!isCollapsed"
    >
        <div
            class="ml-auto col-1 cmps-notification-undo"
            tabindex="-1"
            role="button"
            [attr.aria-label]="'Undo dismiss' | translate"
            (click)="onUndoClick($event)"
        >
            <cmps-icon svgIcon="undo"></cmps-icon>
        </div>
    </div>
    <div
        class="row header"
        [ngClass]="{ dim: isDismissed }"
        [class.cmps-notification--header--expanded]="!isCollapsed"
    >
        <!--FIXME priority css class-->
        <div class="col-2 cmps-notification-icon cmps-notification--icon">
            <div
                class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center"
                [class.cmps-cdk-bg-color-green-100]="
                    notification.priorityId !== NotificationPriority.CRITICAL
                "
                [class.cmps-cdk-bg-color-red-100]="
                    notification.priorityId === NotificationPriority.CRITICAL
                "
            >
                <cmps-icon
                    class="cmps-cdk-fill-white"
                    svgIcon="bullhorn"
                ></cmps-icon>
            </div>
        </div>
        <div
            class="col-9 cmps-notification--content"
            [class.cmps-notification--content--expanded]="!isCollapsed"
            [id]="'notification' + index + 'Content'"
        >
            <div class="cmps-notification--line-wrapper">
                <div class="cmps-notification--line">
                    {{ notification.createdOn | date: 'y-MM-dd h:mm a' }}
                </div>
                <div
                    class="cmps-notification--line"
                    [class.cmps-notification--subject--expanded]="!isCollapsed"
                >
                    {{ notification.subject }}
                </div>
            </div>
        </div>
        <div
            class="col-1 cmps-notification-dismiss cmps-notification--dismiss"
            [hidden]="isDismissed"
            tabindex="-1"
            role="button"
            [attr.aria-label]="'Dismiss' | translate"
            (click)="onDismissClick($event)"
        >
            <cmps-icon svgIcon="delete-outline"></cmps-icon>
        </div>
    </div>
    <div
        class="row"
        [ngClass]="{ dim: isDismissed }"
        [class.cmps-cdk-d-none]="isCollapsed"
        (click)="$event.stopPropagation()"
    >
        <div
            class="col-12"
            tabindex="-1"
            notificationBody
            [body]="notification.body"
            [links]="notification.notificationLinks"
            (linkClick)="onLinkClick($event)"
        ></div>
    </div>
</div>
